// TODO: Replace with tenant-aware admin checks from backend API
// This hardcoded list should eventually be replaced with a backend API call
// that returns whether the current user is an admin for the current tenant
export const ADMIN_EMAILS = [
  'rporter@mpactcollective.com',
  'iomara@mpactcollective.com',
  'josh@endstation.us',
  'peleke@endstation.us',
  'alexandra@propvizer.co'
]; 